export default class GLOBALS {
  static get API_URL() {
    return (process.env.VUE_APP_API_URL || "https://pol.api.dev.eonproduccion.net") + "/v2017001/API/";
  }

  static get API_URL_FILES() {
    return (process.env.VUE_APP_FILES_API_URL || "https://cicg-seg.api.dev.eonproduccion.net") + "/files/php/CICG_SEG_SCM/api/";
  }

  static get DEBUG_MODE() {
    return this.DEBUGMODE;
  }
  static get TESTING_MODE() {
    return this.DEBUGMODE;
  }

  static get LOG_INFO() {
    return "info";
  }
  static get LOG_WARN() {
    return "warn";
  }
  static get LOG_ERROR() {
    return "error";
  }
  static get LOG_LEVEL() {
    return this.DEBUGMODE ? this.LOG_INFO : this.LOG_WARN;
  } //{info, warn, error}

  static get ONE_SECOND() {
    return 1000;
  }
  static get ONE_MINUTE() {
    return 60 * this.ONE_SECOND;
  }

  static DEBUGMODE = true; //true = se escribe en consola y en alertas los detalles de errores, etc.
}
